export enum TimeUnit {
	MINUTES = 'MINUTES',
	HOURS = 'HOURS',
	DAYS = 'DAYS',
}

export const TIME_UNIT_OPTIONS: { value: TimeUnit; label: string }[] = [
	{ value: TimeUnit.MINUTES, label: 'Minutes' },
	{ value: TimeUnit.HOURS, label: 'Hours' },
	{ value: TimeUnit.DAYS, label: 'Days' },
];

const MINUTES_PER_UNIT: Record<TimeUnit, number> = {
	[TimeUnit.MINUTES]: 1,
	[TimeUnit.HOURS]: 60,
	[TimeUnit.DAYS]: 60 * 24,
};

export const timeUnitToMinutes = (value: number, unit: TimeUnit): number => value * MINUTES_PER_UNIT[unit];

export const timeUnitToHours = (value: number, unit: TimeUnit): number => timeUnitToMinutes(value, unit) / 60;

export const formatDurationValue = (value: number | null | undefined, unit: TimeUnit | null | undefined): string => {
	if (value == null || unit == null) return '-';
	const totalMinutes = timeUnitToMinutes(value, unit);
	if (totalMinutes === 0) return '0 minutes';

	const days = Math.floor(totalMinutes / (60 * 24));
	const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
	const minutes = totalMinutes % 60;

	const parts: string[] = [];
	if (days > 0) parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);
	if (hours > 0) parts.push(`${hours} ${hours === 1 ? 'hour' : 'hours'}`);
	if (minutes > 0) parts.push(`${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`);

	return parts.join(', ');
};
